import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ViewChild } from '@angular/core';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { AngularFireModule } from 'angularfire2';
import { CONFIG } from './config/config';
import { routing } from './app.routes';

import { SharedModule } from './shared/shared.module';
import { TogglitFormsModule } from './forms/tog-forms.module';

// Singleton Services
import { ApplicationService } from 'app/shared/services/app/application/application.service';
import { LoginService } from 'app/shared/services/login/login.service';
import { Session } from 'app/shared/services/session/session.service';
import { UserService } from 'app/shared/services/user/user.service';
import { AnalyticsService } from 'app/shared/services/analytics/analytics.service';
import { CsvService } from 'app/shared/services/csv/csv.service';
import { HoverService } from './shared/components/hover/hover.service';
import { AutosizeService } from './shared/components/autosize/autosize.service';
import { ModalService } from './shared/services/modal/modal.service';
import { DashboardService } from 'app/shared/services/dashboard/dashboard.service';
import { Toast } from 'app/shared/components/toast/toast.service';
import { TogglitScreenAuthGuard } from './screens/togglit-screen-auth-guard';

// Auth Guards
import { AdminAuthGuard } from 'app/shared/services/user/admin-auth-guard';

// Components
import { AngularFireStub } from 'app/testing-stubs';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AngularFireModule.initializeApp(CONFIG.DEFAULT_FIREBASE),
    BrowserModule,
    HttpModule,
    SharedModule,
    TogglitFormsModule,
    routing
  ],
  providers: [
    AdminAuthGuard,
    AnalyticsService,
    AngularFireStub,
    DashboardService,
    TogglitScreenAuthGuard,
    ApplicationService,
    CsvService,
    DashboardService,
    LoginService,
    Session,
    Toast,
    HoverService,
    UserService,
    AutosizeService,
    ModalService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /app/src/app/app.module.ts